"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseCoinType = exports.LineIntervalType = void 0;
var LineIntervalType;
(function (LineIntervalType) {
    LineIntervalType["_1m"] = "1m";
    LineIntervalType["_3m"] = "3m";
    LineIntervalType["_5m"] = "5m";
    LineIntervalType["_15m"] = "15m";
    LineIntervalType["_30m"] = "30m";
    LineIntervalType["_1h"] = "1h";
    LineIntervalType["_2h"] = "2h";
    LineIntervalType["_4h"] = "4h";
    LineIntervalType["_6h"] = "6h";
    LineIntervalType["_8h"] = "8h";
    LineIntervalType["_12h"] = "12h";
    LineIntervalType["_1d"] = "1d";
    LineIntervalType["_7d"] = "7d";
    LineIntervalType["_30d"] = "30d";
})(LineIntervalType = exports.LineIntervalType || (exports.LineIntervalType = {}));
var BaseCoinType;
(function (BaseCoinType) {
    BaseCoinType["BTC"] = "BTC.PERP";
    BaseCoinType["ETH"] = "ETH.PERP";
    BaseCoinType["SOL"] = "SOL.PERP";
})(BaseCoinType = exports.BaseCoinType || (exports.BaseCoinType = {}));
